import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ErrorHandler, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, RequestOptions, XHRBackend, Http } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { MyDatePickerModule } from 'mydatepicker';

import { NgxPaginationModule } from 'ngx-pagination';

import { AgentProfileService } from './_services/agent.profile.service';
import { AppComponent } from './app.component';
import { routing } from './app.routes';
import { AppDialogComponent } from './details/consents/app.dialog.component';
import { GrantUpdateDialogComponent } from './details/consents/grant-update/grant-update.dialog.component';
import { CustomerUpdateDialogComponent } from './details/customer-update/customer.update.dialog.component';
import { DetailsComponent } from './details/details.component';
import { KycUpdateDialogComponent } from './details/kyc/kyc.update.dialog.component';
import { KYCINFODialogComponent } from './details/kyc/kyc.informational.dailog.compnent';
import { MailaddComponent } from './details/mailadd/mail.add.dialog.component';
import { MailupdateComponent } from './details/mailupdate/mail.update.dialog.component';
import { MSISDNupdateComponent } from './details/msisdnupdate/msisdn.update.dialog.component';
import { MSISDNconfirmComponent } from './details/msisdnupdate/msisdn.confirm.dialog.component';
import { MobileConnectComponent } from './details/mobile-connect/mobile.connect.dialog.component';
import { GatewayHistoryComponent } from './details/gateway-history/gateway-history.dialog.component';
import { NotificationDialogComponent } from './notification/notification.dialog.component';
import { OpcoFormComponent } from './opco/opco-form.component';
import { SearchFormComponent } from './search/search-form.component';
import { UserSessionComponent } from './user-session/user-session.component';
import { CustomErrorHandler } from './_services/errorhandler.service';
import { LogoutDialogComponent } from './logout/logout.dialog.component';
import { ResetDialogComponent } from './reset/reset.dialog.component';
import { ResetPinDialogComponent } from './reset/reset.pin.dialog.component';
import { ActivateAccountDialogComponent } from './activateaccount/activate.account.dialog.component';
import { UnlockAccountDialogComponent } from './unlockaccount/unlock.account.dialog.component';
import { RememberMeComponent } from './rememberme/rememberme.dialog.component';
import { LogoutCustomerComponent } from './details/logout-customer/logout.customer.dialog.component';
import { SmsurlComponent } from './smsurl/smsurl.component';
import { SmscloseComponent } from './smsurl/smsclose.component'
import { SiteLayoutComponent } from './site-layout/site-layout.component';
import { SiteHeaderComponent } from './site-header/site-header.component';
import { SiteFooterComponent } from './site-footer/site-footer.component';

import { KycRevokeDialogComponent } from './details/kyc/kyc.revoke.dialog.component';
import { KYCHistoryDialogComponent } from './details/kyc/kyc.history.dialog.component';
import { SuccessfullLogin } from './details/mc-successfull-login/mc.successfull.login.component';


import { DeleteCofirmationDialogComponent } from './shared/delete-confirmation/delete-confirmation.dialog.component';
import { DateTimeFormatPipe } from './shared/datetime-format/datetime.pipe';


import { TranslateService } from './_services/translate.service';
import { TranslatePipe } from './shared/translate/translate.pipe';

import {InterceptedHttp} from "./_services/http.service";

import { LoaderService } from './_services/loader.service';
import { TimezoneService } from './_services/timezone.service';
import { SessionTimeoutService } from './_services/sessionTimeout.service';

export function setupTranslateFactory(service: TranslateService): Function {

  let selectedLanguage = localStorage.getItem('language');
  return () => service.use(selectedLanguage);
}

export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions): Http {
    return new InterceptedHttp(xhrBackend, requestOptions);
}

@NgModule({
  declarations: [
    AppComponent,
    OpcoFormComponent,
    SearchFormComponent,
    DetailsComponent,
    UserSessionComponent,
    AppDialogComponent,
    MailupdateComponent,
    MSISDNupdateComponent,
    MSISDNconfirmComponent,
    MailaddComponent,
    NotificationDialogComponent,
    MobileConnectComponent,
    GatewayHistoryComponent,
    CustomerUpdateDialogComponent,
    KycUpdateDialogComponent,
    GrantUpdateDialogComponent,
    LogoutDialogComponent,
    ResetDialogComponent,
    ResetPinDialogComponent,
    ActivateAccountDialogComponent,
    UnlockAccountDialogComponent,
    RememberMeComponent,
    LogoutCustomerComponent,
    SmsurlComponent,
    SmscloseComponent,
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    DeleteCofirmationDialogComponent,
    DateTimeFormatPipe,
    TranslatePipe,
    KYCHistoryDialogComponent,
    KycRevokeDialogComponent,
    SuccessfullLogin,
    KYCINFODialogComponent
  ],
  imports: [
    BrowserModule,
    MyDatePickerModule,
    routing,
    FormsModule,
    BootstrapModalModule,
    HttpModule,
    NgxPaginationModule,
  ],
  providers: [
  SessionTimeoutService,
  TranslateService,
  LoaderService,
  TimezoneService,
    { provide: APP_INITIALIZER, useFactory: setupTranslateFactory, deps: [TranslateService], multi: true },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: AgentProfileService, useClass: AgentProfileService },
    { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] }
  ],

  // everything, that pops up needs to be declared here
  entryComponents: [
    AppDialogComponent,
    MailupdateComponent,
    MSISDNupdateComponent,
    MSISDNconfirmComponent,
    MailaddComponent,
    CustomerUpdateDialogComponent,
    NotificationDialogComponent,
    MobileConnectComponent,
    GatewayHistoryComponent,
    KycUpdateDialogComponent,
    GrantUpdateDialogComponent,
    LogoutDialogComponent,
    ResetDialogComponent,
    ResetPinDialogComponent,
    ActivateAccountDialogComponent,
    UnlockAccountDialogComponent,
    RememberMeComponent,
    LogoutCustomerComponent,
    DeleteCofirmationDialogComponent,
    KYCHistoryDialogComponent,
    KycRevokeDialogComponent,
    SuccessfullLogin,
    KYCINFODialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts